import { BreadcrumbStateInfo, SiteUrlsContext } from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Route } from 'react-router';
import { defaultMemoize } from 'reselect';
import { createCatalogDatabasesBreadcrumb } from './BreadcrumbFactories';
import { BreadcrumbsUpdater } from './BreadcrumbsUpdater';

function createDatabasesBreadcrumbsList(
  urls: SiteUrls,
  urlSuffix: string,
): ReadonlyArray<BreadcrumbStateInfo> {
  return [
    createCatalogDatabasesBreadcrumb(urls, urlSuffix)
  ];
}

export type DatabasesBreadcrumbsUpdaterProps = {
};

export class DatabasesBreadcrumbsUpdater extends React.Component<DatabasesBreadcrumbsUpdaterProps> {

  // tslint:disable-next-line: typedef
  private readonly memoizedCreateDatabasesBreadcrumbsList = defaultMemoize(createDatabasesBreadcrumbsList);

  public render() {
    return (
      <SiteUrlsContext.Consumer>
        {urls =>
          <Route>
            {({ location }) => {
              const breadcrumbs = this.memoizedCreateDatabasesBreadcrumbsList(urls, location.search);
              return (
                <BreadcrumbsUpdater breadcrumbs={breadcrumbs} />
              );
            }}
          </Route>
        }
      </SiteUrlsContext.Consumer>
    );
  }

}
